import axios from 'axios';

// const apiUrl = 'https://test.com/';

export const urls = {
  getProjects: 'projects',
  notifyFormHub: 'https://api.hsforms.com/submissions/v3/integration/submit/3938490/bb3636b8-6b42-4036-9472-c519416d2c53',
  participationFormHub: 'https://api.hsforms.com/submissions/v3/integration/submit/3938490/41dce5b2-c273-49b7-90dd-a8afa7ba1d2b',
};

export const api = axios.create({
  timeout: 25000,
});

api.interceptors.response.use(
  response => ({ error: false, data: response.data }),
  error => ({ error: true, code: JSON.parse(error.request.response).message }),
);



// WEBPACK FOOTER //
// ./src/api/request.js